/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Cart count badges - Animate every 5 sec
// setInterval(() => {
//     document.querySelectorAll('.cart-count-badge').forEach((badge) => {
//         badge.classList.add(badge.dataset.animateClass)

//         setTimeout(() => {
//             badge.classList.remove(badge.dataset.animateClass)
//         }, 2000)
//     })
// }, 5000)

// Scroll to F.A.Q through a hash link
if (window.location.hash.includes('faq')) {
    setTimeout(() => {
        const section = document.querySelector('.richtext')
        if (section) {
            section.scrollIntoView()
        }
    }, 500)
}

// Cycle words for West and Willow
document.querySelectorAll('.ww-cycle-words').forEach(element => {
    console.log(element)
    let x = 0
    setInterval(() => {
        const words = ['mug', 'pet bowl', 'accessory', 'phone case', 'stickers']

        element.style.transition = 'all .2s ease-out'
        element.style.opacity = 0

        setTimeout(() => {
            element.textContent = words[x]
            element.style.opacity = 1
        }, 200)

        x += 1

        if (x === words.length - 1) {
            x = 0
        }
    }, 2000)
})

// Insert Offcanvas Nav Announcements within the megamenu in desktop
if (window.matchMedia('(min-width: 1200px)').matches) {
    const element = document.querySelector('#offcanvas-nav-announcements')
    const megamenuColumn = document.querySelector('.dropdown-megamenu .col-5')

    // The carousel only renders when an announcement block is visible
    if (element && megamenuColumn) {
        element.classList.remove('mb-8')
        element.classList.add('mb-4')

        megamenuColumn.insertAdjacentElement('afterbegin', element)
    }
}

function showRandomOrders() {
  // Generating a random number between 45 and 98
  const randomNumber = Math.floor(Math.random() * (98 - 45 + 1)) + 45;

  // Constructing the message with an emoji and the random number
  return `🕒 <span style="color: red;">Going FAST!</span>  ${randomNumber} orders until we reach artist capacity.`;
}

// Using the function to display the message
document.addEventListener('DOMContentLoaded', function() {
  const messageElement = document.getElementById('artCapacityMessage');
  if (messageElement) {
    messageElement.innerHTML = showRandomOrders();
  }
});

async function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
